import {AFD,getLS} from 'devegram-javascript-util'

const baseUrl = '/xapi/Voip/Vendor';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {},
    actions: {
        async assign(context, params) {
           
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/assign',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async dashboardInfo (context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dashboardInfo'
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async rateDashboardInfo (context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/rateDashboardInfo'
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async downloadVosRate(context, params) {
            let fileName = 'ffr-customer-vos-rate'
            let fileType = 'xlsx'

            const link = document.createElement('a');
            link.href = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + ":" + process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_PORT + baseUrl + '/downloadVosRate/' + params.id;
            link.setAttribute('download', fileName + '.' + fileType);
            //link.setAttribute('target', "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let page = (params.page) ? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id + '?page=' + page
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async listToAssign(context, params) {
            let current_profile_id = getLS('user').profile_id;
            current_profile_id = "&current_profile_id=" + current_profile_id;
            let current_user_id = '&current_user_id='+getLS('user').id;
            let customerUserId = (params.customerUserId) ? "&customerUserId="+ params.customerUserId : ''
            
            let page = (params.page) ? params.page : 1
            let showOnlyHasUnconnected = (params.showOnlyHasUnconnected == true) ? '&showOnlyHasUnconnected=1' : ''
            let listAllOption = (params.listAllOption == true) ? '&listAllOption=1' : ''
            let filterOption = '&filterOption=' + params.filterOption
            let pageChunk = "&page-chunk=20"
            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search + pageChunk + showOnlyHasUnconnected + listAllOption + filterOption+ current_profile_id + current_user_id + customerUserId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list(context, params) {
            let current_profile_id = getLS('user').profile_id;
            current_profile_id = "&current_profile_id=" + current_profile_id;
             
              let current_user_id = '&current_user_id='+getLS('user').id;
            let page = (params.page) ? params.page : 1
            let showOnlyHasUnconnected = (params.showOnlyHasUnconnected == true) ? '&showOnlyHasUnconnected=1' : ''
            let listAllOption = (params.listAllOption == true) ? '&listAllOption=1' : ''
            let filterOption = '&filterOption=' + params.filterOption
            let pageChunk = "&page-chunk=20"
            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search + pageChunk + showOnlyHasUnconnected + listAllOption + filterOption+ current_profile_id + current_user_id,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async exportVendors(context, params) {
            let fileName = 'ffr-vos-vendors-export'
            let fileType = 'xlsx'

            const link = document.createElement('a');
            link.href = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + ":" + process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_PORT + baseUrl + '/exportVendors';
            link.setAttribute('download', fileName + '.' + fileType);
            //link.setAttribute('target', "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async getDropDownList(context, params = {}) {
            let divisionId = (params.divisionId)? '/' + params.divisionId : ''
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList' + divisionId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    context.state.dropdownList = r.data
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async dropDownDestinationsList(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownDestinationsList/' + params.vendorId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },

        /* Vendor APIs */
        async removeRate(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/removeRate',
                data: params
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async deleteRateDocument(context, params) {
            let api = {
                verb: 'delete',
                service: moduleAjaxService,
                url: baseUrl + '/rateDocument/' + params.id,
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async importRates(context, params) {
            let noLoadingScreen = false
            if (params.hasOwnProperty('noLoading') && params.noLoading) {
                noLoadingScreen = params.noLoading
            }

            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/importRates',
                data: AFD(params.data),
                noLoadingScreen: noLoadingScreen
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async createManualRate(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/createManualRate',
                data: AFD(params.data),
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async createOrUpdateRate(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/createOrUpdateRate',
                data: AFD(params.data),
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getVendorRatesCounter(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getVendorRatesCounter/' + params.id,
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getRatesDocumentList(context, params) {
            let page = (params.page) ? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getRatesDocumentList?page=' + page
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getRateDocumentStatus(context, rateDocumentId) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getRateDocumentStatus?id=' + rateDocumentId,
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getVendorRate(context, params) {
            let page = (params.page) ? params.page : 1
            let pageChunk = '&page-chunk=24'
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getVendorRate/' + params.id + '?page=' + page + '&destination_id=' + params.destinationId + '&dialcode=' + params.dialcode + pageChunk
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getVendorDivision(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getVendorDivision/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getVendorDivisionByName(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getVendorDivisionByName/' + encodeURIComponent(params.name)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
    }

};

export default api
